import React from 'react';
import { Clock } from 'lucide-react';
import { CartSheet } from '../cart';
import { businessInfo } from '../../mock';

// Horario por local (cada uno tiene el suyo). Los domingos SOLO abre la
// Sucursal; la Matriz permanece cerrada.
const HorariosPorLocal = () => (
  <div className="text-center text-xs opacity-80 leading-relaxed">
    <div>📅 <strong>Matriz:</strong> Lun-Sáb 08:30–19:00 · Domingos cerrado</div>
    <div>📅 <strong>Sucursal:</strong> Lun-Vie 10:00–19:00 · Sáb 09:00–18:00 · Dom 09:00–13:00</div>
    <div className="opacity-80">Los domingos solo atiende la Sucursal (09:00–13:00).</div>
  </div>
);

const Header = React.forwardRef(({
  showAfterHoursWarning,
  openStatus = {},
  cartSheetProps
}, ref) => {
  // Domingos (u otros momentos) en que la Matriz está cerrada pero la Sucursal abierta.
  const soloSucursal = !showAfterHoursWarning && openStatus.sucursal && !openStatus.matriz;
  return (
    <>
      <header ref={ref} className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        {showAfterHoursWarning && (
          <div className="bg-[#2c1810]/90 text-[#f5deb3] py-2 px-4">
            <div className="container mx-auto">
              <div className="flex items-center justify-center gap-3 flex-wrap">
                <div className="flex items-center gap-2">
                  <Clock className="w-4 h-4" />
                  <span className="text-sm font-medium">⏰ Estamos cerrados</span>
                </div>
                <span className="hidden md:inline text-white/80">|</span>
                <p className="text-xs text-center opacity-90">
                  Tu pedido será procesado a primera hora de nuestro próximo día laboral
                </p>
              </div>
              <HorariosPorLocal />
            </div>
          </div>
        )}
        {soloSucursal && (
          <div className="bg-[#6b5447] text-[#f5deb3] py-2 px-4">
            <div className="container mx-auto flex items-center justify-center gap-2 flex-wrap text-center">
              <Clock className="w-4 h-4" />
              <span className="text-sm font-medium">
                Hoy solo atiende la <strong>Sucursal</strong> (09:00–13:00). La Matriz está cerrada.
              </span>
            </div>
          </div>
        )}
        <nav className="container mx-auto px-4 md:px-6 py-2 md:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img src="/assets/logo.png" alt="Brazolovers Logo" className="h-10 w-auto" />
              <div className="flex flex-col items-center">
                <div className="text-xl md:text-2xl font-bold text-chocolate leading-tight">{businessInfo.name}</div>
                <div className="text-xs md:text-sm text-caramel">{businessInfo.tagline}</div>
              </div>
            </div>
            
            <div className="flex items-center space-x-4 md:space-x-6">
              <a href="#productos" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Productos</a>
              <a href="#galletas" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Galletas</a>
              <a href="#cakes" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Pasteles</a>
              <a href="#panaderia" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Panadería</a>
              <a href="#desayunos" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Desayunos</a>
              <a href="#menu-sal" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Menú Salado</a>
              <a href="#bebidas" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Bebidas</a>
              <a href="#nosotros" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Nosotros</a>
              <a href="#contacto" className="text-chocolate hover:text-caramel transition-colors hidden xl:block">Contacto</a>
              
              <CartSheet {...cartSheetProps} />
            </div>
          </div>
          
          <div className="flex justify-center mt-2 xl:hidden">
            <div className="flex items-center gap-2 bg-cream/80 rounded-full px-3 py-1.5 overflow-x-auto scrollbar-hide">
              <a href="#productos" className="text-xs font-medium text-chocolate hover:text-caramel transition-colors whitespace-nowrap">Brazos</a>
              <span className="text-gray-300">•</span>
              <a href="#galletas" className="text-xs font-medium text-chocolate hover:text-caramel transition-colors whitespace-nowrap">Galletas</a>
              <span className="text-gray-300">•</span>
              <a href="#cakes" className="text-xs font-medium text-chocolate hover:text-caramel transition-colors whitespace-nowrap">Pasteles</a>
              <span className="text-gray-300">•</span>
              <a href="#panaderia" className="text-xs font-medium text-chocolate hover:text-caramel transition-colors whitespace-nowrap">Panadería</a>
              <span className="text-gray-300">•</span>
              <a href="#desayunos" className="text-xs font-medium text-chocolate hover:text-caramel transition-colors whitespace-nowrap">Desayunos</a>
              <span className="text-gray-300">•</span>
              <a href="#menu-sal" className="text-xs font-medium text-chocolate hover:text-caramel transition-colors whitespace-nowrap">Menú Salado</a>
              <span className="text-gray-300">•</span>
              <a href="#bebidas" className="text-xs font-medium text-chocolate hover:text-caramel transition-colors whitespace-nowrap">Bebidas</a>
              <span className="text-gray-300">•</span>
              <a href="#contacto" className="text-xs font-medium text-chocolate hover:text-caramel transition-colors whitespace-nowrap">Contacto</a>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
});

Header.displayName = 'Header';

export default Header;
